import EditableLabelGroupFreeFlow from "./examples/EditableLabelGroup.FreeFlow.Example";
import EditableLabelGroupSingleLine from "./examples/EditableLabelGroup.SingleLine.Example";
import EditableLabelGroupPromises from "./examples/EditableLabelGroup.Promises.Example";

export default [
    {
        title: "Multi-line label group",
        component: EditableLabelGroupFreeFlow,
        code: require("!raw-loader!./examples/EditableLabelGroup.FreeFlow.Example.tsx"),
        dependencies: {
            "LabelData.tsx": require("!raw-loader!./examples/LabelData.tsx")
        }
    },
    {
        title: "Single-line label group",
        component: EditableLabelGroupSingleLine,
        code: require("!raw-loader!./examples/EditableLabelGroup.SingleLine.Example.tsx"),
        dependencies: {
            "LabelData.tsx": require("!raw-loader!./examples/LabelData.tsx")
        }
    },
    {
        title: "Asynchronous label group",
        component: EditableLabelGroupPromises,
        code: require("!raw-loader!./examples/EditableLabelGroup.Promises.Example.tsx"),
        dependencies: {
            "LabelData.tsx": require("!raw-loader!./examples/LabelData.tsx")
        }
    }
];
